import { ArrowRight, ShieldCheck, Award } from 'lucide-react';
import { TID } from '@/constants/testIds';
import { FOUNDERS } from '@/constants/content';

export default function Hero() {
    const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

    return (
        <section id="home" className="relative pt-28 lg:pt-36 pb-16 lg:pb-24 overflow-hidden">
            {/* Decorative background */}
            <div className="absolute inset-0 -z-10">
                <div className="absolute inset-0 bg-gradient-to-b from-soft to-white" />
                <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-gold-50 blur-3xl opacity-70" />
                <div className="absolute top-1/3 -left-32 w-[420px] h-[420px] rounded-full bg-forest-50 blur-3xl opacity-50" />
                <div className="absolute inset-0 grain opacity-40" />
            </div>

            <div className="container-wl grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                {/* LEFT — typography first */}
                <div className="lg:col-span-7">
                    <div className="flex items-center gap-3 mb-6 animate-fade-up">
                        <span className="gold-rule" />
                        <span className="overline">Trusted Advisory · Est. for Generations</span>
                    </div>

                    <h1 className="font-display-bold text-ink leading-[1.05] text-[44px] sm:text-5xl lg:text-[68px] xl:text-[76px] tracking-tight">
                        Helping Families
                        <span className="block">Professionals & Business Owners</span>
                        <span className="block">
                            Build{' '}
                            <span className="italic text-gold-600">Lasting Wealth</span>
                        </span>
                    </h1>

                    <p className="mt-7 text-[17px] lg:text-lg text-ink/70 leading-relaxed max-w-xl">
                        Trusted financial advisory services with{' '}
                        <strong className="text-ink">62+ years</strong> of combined experience and{' '}
                        <strong className="text-ink">500+</strong> satisfied clients — built on
                        transparency, discipline and a long-term view.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-4">
                        <button
                            onClick={() => go('contact')}
                            data-testid={TID.heroBookConsultation}
                            className="btn-primary"
                        >
                            Book a Consultation
                            <ArrowRight className="w-4 h-4" />
                        </button>
                        <button
                            onClick={() => go('contact')}
                            data-testid={TID.heroContactUs}
                            className="btn-secondary"
                        >
                            Contact Us
                        </button>
                    </div>

                    <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 items-center text-[13px] text-ink/70">
                        <div className="flex items-center gap-2">
                            <ShieldCheck className="w-4 h-4 text-forest" />
                            <span>Client-First Fiduciary Mindset</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Award className="w-4 h-4 text-gold-600" />
                            <span>62+ Years of Combined Experience</span>
                        </div>
                    </div>
                </div>

                {/* RIGHT — founder montage */}
                <div className="lg:col-span-5">
                    <div className="relative">
                        {/* Big card — Bhartendu */}
                        <div className="relative rounded-xl overflow-hidden shadow-hover bg-soft aspect-[4/5]">
                            <img
                                src="https://i.postimg.cc/XYgPhSwJ/file-00000000398c720ba33194965c861b85.png"
                                alt={FOUNDERS[1].name}
                                className="w-full h-full object-contain bg-white"
                            />
                            <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-navy/90 via-navy/40 to-transparent">
                               
                            </div>
                        </div>

                        {/* Floating cards */}
                       

                        {/* Gold corner accent */}
                        <div className="absolute -top-3 -left-3 w-16 h-16 border-t-2 border-l-2 border-gold" aria-hidden />
                        <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-2 border-r-2 border-gold" aria-hidden />
                    </div>
                </div>
            </div>
        </section>
    );
}
